module.exports = __webpack_public_path__ + "54f68be7719e43aef2bfc43a29a40d19.svg";